module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_footer_marriage-736f5d3716057964cecfd22569069500.svg";